import { makeStyles } from '@mui/styles';

import { translate } from '@openclassrooms/translations';

import CCBYIcon from './images/CCBYIcon';
import CCNCIcon from './images/CCNCIcon';
import CCNDIcon from './images/CCNDIcon';
import CCSAIcon from './images/CCSAIcon';
import CCIcon from './images/CCIcon';

interface CourseLicensesProps {
  license: string;
}

const useStyles = makeStyles(({ spacing }) => ({
  licenseList: {
    listStyle: 'none',
    display: 'flex',
    padding: 0,
    margin: 0,
  },
  iconsWrapper: {
    display: 'flex',
    marginRight: spacing(1),
  },
  link: {
    color: 'currentcolor',
  },
  icon: {
    width: 20,
    height: 20,
  },
}));

const CourseLicenses = ({ license }: CourseLicensesProps) => {
  const classes = useStyles();
  const licenseUrl = `https://creativecommons.org/licenses/${license
    .replace('CC-', '')
    .toLowerCase()}/${license === 'CC-BY-SA' ? '4.0' : '2.0'}/`;

  const licenseStringToComponents = () => {
    const licenses = license.split('-');
    const iconsPerLicense = {
      BY: (
        <li className={classes.iconsWrapper} key="BY">
          <CCBYIcon className={classes.icon} aria-label="BY" aria-hidden="false" />
        </li>
      ),
      NC: (
        <li className={classes.iconsWrapper} key="NC">
          <CCNCIcon className={classes.icon} aria-label="NC" aria-hidden="false" />
        </li>
      ),
      ND: (
        <li className={classes.iconsWrapper} key="ND">
          <CCNDIcon className={classes.icon} aria-label="ND" aria-hidden="false" />
        </li>
      ),
      SA: (
        <li className={classes.iconsWrapper} key="SA">
          <CCSAIcon className={classes.icon} aria-label="SA" aria-hidden="false" />
        </li>
      ),
      default: (
        <li className={classes.iconsWrapper} key="CC">
          <CCIcon className={classes.icon} aria-label="CC" aria-hidden="false" />
        </li>
      ),
    };

    return licenses.map((licenseName) => iconsPerLicense[licenseName] || iconsPerLicense.default);
  };

  return (
    <a className={classes.link} href={licenseUrl} title={translate('course.license.label')}>
      <ul className={classes.licenseList}>{licenseStringToComponents()}</ul>
    </a>
  );
};

export default CourseLicenses;
